const SidebarState={
    width:'18%'
}

export default SidebarState;